
  import { Vue, Component } from 'vue-property-decorator';

  @Component
  export default class SponsorSiteInfoTests extends Vue {
    created() {
    }

    mounted() {
    }
  }
